import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RequiredDetailsForDOFE, apiDOFEGetGridList, apiGetCustomerDetailsByPassportNo, apiGetDetailsByRegisterNo, apiProceedFEPolicyGeneration, apiSaveFECustomerDetails } from "../api/dofeApi";

export const getRequiredDetailsForDOFEAsync = createAsyncThunk(
  "get required details for DOFE",
  async (formValue) => {
    const response = await RequiredDetailsForDOFE(formValue);
    return response;
  }
);

export const GetCustomerDetailsByPassportNo = createAsyncThunk(
  "get Customer Details By PassportNo",
  async (formValue) => {
    const response = await apiGetCustomerDetailsByPassportNo(formValue);
    return response;
  }
);

export const apiSaveFECustomerDetailsAsync = createAsyncThunk(
  "api Save FECustomer Details",
  async (formValue) => {
    const response = await apiSaveFECustomerDetails(formValue);
    return response;
  }
);

export const ProceedFEPolicyGeneration = createAsyncThunk(
  "api Save FECustomer Details",
  async (formValue) => {
    const response = await apiProceedFEPolicyGeneration(formValue);
    return response;
  }
);

export const GetDetailsByRegisterNo = createAsyncThunk(
  "Get Details By Register No",
  async (formValue) => {
    const response = await apiGetDetailsByRegisterNo(formValue);
    return response;
  }
);

export const DOFEGetGridList = createAsyncThunk(
  "Get Details By Register No",
  async (formValue) => {
    const response = await apiDOFEGetGridList(formValue);
    return response;
  }
);

const dofeSlice = createSlice({
  name: "DOFE",
  initialState: [],
  reducers: {},
  extraReducers: (builder) => {},
});

export default dofeSlice.reducer;
